import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/Navigation/ProtectedRoute";
import AdminRoute from "./components/Navigation/AdminRoute";
import RecruiterRoute from "./components/Navigation/RecruiterRoute";
import PublicRoute from "./components/Navigation/PublicRoute";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import NotFound from "./Pages/NotFound";
import { LoginProvider } from "./Context/Auth";
import Sales from "./Pages/Sales";
// import Reports from "./Pages/Reports";
import SubmissionsTable from "./Pages/Reports/SubmissionsTable";
import Recruiting from "./Pages/Recruiting";
import Executives from "./Pages/Executives/ExecutivesTable";
import ForgotPassword from "./Pages/ForgotPassword";
import Reset from "./Pages/ResetPassword";
import AddEmployeeForm from "./Pages/Executives/ExecutivesTable/AddEmployeeForm";
//import { User } from "lucide-react";
import { UserProvider } from "./Context/User";
import EditEmployeeForm from "./Pages/Executives/ExecutivesTable/EditEmployeeForm";
//import AddClientForm from "./Pages/Sales/AddClientForm";
import EditClientForm from "./Pages/Sales/EditClientModal";
import ManageEmployee from "./Pages/Sales/ManageEmployee";
import { EmployeeProvider } from "./Context/Employee";
import UploadDocuments from "./Pages/UploadDocuments";
import ArchivedDocuments from "./Pages/UploadDocuments/ArchivedDocuments";
import { ClientProvider } from "./Context/Client";
import { RecruiterProvider } from "./Context/Recruiter";

import { SalesProvider } from './Context/Sales';
import UpdatePassword from "./Pages/UpdatePassword";
import ProfileUpdate from "./Pages/ProfileUpdate";
import NotFoundWrapper from "./Pages/NotFound/NotFoundWrapper";
import Submission from "./Pages/Recruiting/Submission";
import Candidates from "./Pages/Recruiting/Candidates";
import CandidateDocuments from "./Pages/Recruiting/CandidateDocuments";
import CandidateForm from "./Pages/Recruiting/Candidates/CandidateForm";
import Notes from "./Pages/Notes";

const App = () => {
  return (
    <SalesProvider>
      <LoginProvider>
        <UserProvider>
          <EmployeeProvider>
          <ClientProvider>
          <RecruiterProvider>
          <Router>
            <Routes>
              <Route path="/" element={<ProtectedRoute />}>
                <Route exact path="/" element={<Dashboard />} />
                <Route exact path="/sales" element={<Sales />} />
                <Route exact path="/reports/submissions" element={<SubmissionsTable />} />
                <Route exact path="/manage-employees" element={<ManageEmployee/>} />
                <Route exact path="/manage-employees/uploaddocuments/:id" element={<UploadDocuments/>}/>
                <Route exact path="/manage-employees/:id/documents/archived" element={<ArchivedDocuments/>}/>
                <Route path="/documents/:id" element={<UploadDocuments />} />
                <Route path="/archived-documents/:id" element={<ArchivedDocuments />} />
                <Route path="/updatePassword" element={<UpdatePassword />}/>
                <Route path="/profile-update" element={<ProfileUpdate />} />
                <Route path="/notes" element={<Notes />} />
                
                {/* Admin-only routes */}
                <Route element={<AdminRoute />}>
                  <Route exact path="/users" element={<Executives />} />
                  <Route exact path="/edituser/:id" element={<EditEmployeeForm />} />
                  <Route exact path="/addemployee" element={<AddEmployeeForm />} />
                  {/* <Route exact path="/editclient/:id" element={<EditClientForm/>} /> */}
                  {/* <Route exact path="/addclient" element={<AddClientForm />} /> */}
                </Route>

                <Route element={<RecruiterRoute />}>
                  <Route exact path="/requirements" element={<Recruiting />} />
                  <Route exact path="/requirements/:id" element={<Submission />} />
                  <Route exact path="/candidates" element={<Candidates />} />
                  <Route exact path="/candidates/add" element={<CandidateForm />} />
                  <Route exact path="/candidates/edit/:id" element={<CandidateForm />} />
                  <Route exact path="/candidates/:id/documents" element={<CandidateDocuments />} />
                  
               
                </Route>
              </Route>
              
              <Route element={<PublicRoute />}>
                <Route path="/login" element={<Login />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/resetpassword/:token" element={<Reset />} />
              </Route>
              <Route exact path="*" element={<NotFoundWrapper />} />
            </Routes>
          </Router>
          </RecruiterProvider>
          </ClientProvider>
          </EmployeeProvider>
        </UserProvider>
      </LoginProvider>
    </SalesProvider>
  );
};

export default App;
